import React from 'react';
import './LegalPages.css';
import Footer from './Footer';

function TermsOfService() {
  return (
    <div className="App">
      <div className="legal-page">
        <div className="container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: January 13, 2026</p>
          
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              These Terms of Service ("Terms") govern your access to and use of the website (lilleytechsyndicate.com), 
              software products, technology spin-offs, and any related services (collectively, the "Services") provided 
              by Lilley Tech Syndicate LLC ("we," "our," or "us"). By accessing or using the Services, you agree to be 
              bound by these Terms and our Privacy Policy. If you do not agree, you must not access or use the Services.
            </p>
            <p>
              If you are using the Services on behalf of an entity, you represent that you have the authority to bind that 
              entity to these Terms. We may require you to accept these Terms explicitly (e.g., via a checkbox) for certain 
              features.
            </p>
          </section>

          <section>
            <h2>2. Eligibility</h2>
            <p>
              You must be at least 18 years old (or the age of majority in your jurisdiction) to use the Services. By using 
              the Services, you represent that you meet this requirement. We do not knowingly provide Services to individuals 
              under 18.
            </p>
          </section>

          <section>
            <h2>3. Use of Services</h2>
            <p>
              You agree to use the Services only for lawful purposes and in compliance with these Terms and all applicable 
              laws and regulations. Prohibited activities include, but are not limited to:
            </p>
            <ul>
              <li>Violating any local, state, national, or international laws or regulations.</li>
              <li>Infringing on the intellectual property, privacy, or other rights of others.</li>
              <li>Transmitting or uploading harmful, offensive, defamatory, obscene, discriminatory, or illegal content.</li>
              <li>Engaging in unauthorized access, hacking, or interference with the Services, servers, or networks.</li>
              <li>Distributing viruses, malware, spam, or any destructive code.</li>
              <li>Impersonating any person or entity, or misrepresenting your affiliation.</li>
              <li>Harassing, stalking, or threatening others.</li>
              <li>Collecting or storing personal data about other users without consent.</li>
              <li>Using automated scripts, bots, or scrapers without our permission.</li>
            </ul>
            <p>
              We reserve the right to monitor usage and investigate violations. If user-generated content is allowed (e.g., 
              comments or uploads), you grant us a non-exclusive, royalty-free, perpetual license to use, modify, and display 
              it as needed for the Services.
            </p>
          </section>

          <section>
            <h2>4. Intellectual Property</h2>
            <p>
              All content, materials, and features of the Services—including text, graphics, logos, images, software, code, 
              designs, and trademarks—are owned by us or our licensors and protected by copyright, trademark, patent, and 
              other intellectual property laws.
            </p>
            <p>
              We grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Services for 
              personal or internal business purposes, subject to these Terms. You may not:
            </p>
            <ul>
              <li>Copy, reproduce, distribute, modify, or create derivative works from our content without written permission.</li>
              <li>Reverse engineer, decompile, or disassemble any software or technology.</li>
              <li>Remove or alter any proprietary notices.</li>
            </ul>
            <p>
              If you believe your IP rights are infringed, contact us per Section 14. We comply with the Digital Millennium 
              Copyright Act (DMCA) and may terminate repeat infringers.
            </p>
          </section>

          <section>
            <h2>5. User Accounts</h2>
            <p>To access certain features, you may need to create an account. You agree to:</p>
            <ul>
              <li>Provide accurate, current, and complete information during registration.</li>
              <li>Maintain the security and confidentiality of your credentials.</li>
              <li>Notify us immediately of any unauthorized access or use.</li>
              <li>Be responsible for all activities under your account.</li>
            </ul>
            <p>
              We may suspend or terminate accounts for violations. You may close your account at any time by contacting us, 
              but we may retain data as per our Privacy Policy.
            </p>
          </section>

          <section>
            <h2>6. Services Description and Modifications</h2>
            <p>
              We develop and operate software products and technology spin-offs. Descriptions of Services are for informational 
              purposes; we do not guarantee specific features or outcomes.
            </p>
            <p>
              We may modify, update, suspend, or discontinue any part of the Services at any time without notice or liability. 
              If Services are paid, refer to any separate subscription agreements for details on fees, billing, refunds, and 
              cancellations.
            </p>
          </section>

          <section>
            <h2>7. Disclaimer of Warranties</h2>
            <p>
              The Services are provided "as is" and "as available," without warranties of any kind, express or implied, 
              including but not limited to warranties of merchantability, fitness for a particular purpose, non-infringement, 
              accuracy, or uninterrupted/error-free operation. We do not warrant that defects will be corrected or that the 
              Services are free of viruses.
            </p>
            <p>
              To the extent permitted by law, use of the Services is at your own risk. Some jurisdictions do not allow 
              disclaimer of implied warranties, so this may not apply fully to you.
            </p>
          </section>

          <section>
            <h2>8. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, we, our affiliates, officers, directors, employees, and agents shall 
              not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, 
              data, use, goodwill, or other intangible losses, arising from:
            </p>
            <ul>
              <li>Your use or inability to use the Services.</li>
              <li>Unauthorized access or alterations to your data.</li>
              <li>Content or conduct of third parties.</li>
              <li>Any other matter related to the Services.</li>
            </ul>
            <p>
              Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim (or $100 if 
              no payment). This limitation applies even if advised of the possibility of such damages. Some jurisdictions limit 
              such exclusions, so they may not apply to you.
            </p>
          </section>

          <section>
            <h2>9. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless us, our affiliates, officers, directors, employees, and agents 
              from any claims, liabilities, damages, losses, costs, or expenses (including reasonable attorneys' fees) arising from:
            </p>
            <ul>
              <li>Your use of the Services.</li>
              <li>Your violation of these Terms or applicable laws.</li>
              <li>Your content or actions that infringe third-party rights.</li>
            </ul>
            <p>
              We reserve the right to assume control of any defense, at your expense.
            </p>
          </section>

          <section>
            <h2>10. Third-Party Links and Services</h2>
            <p>
              The Services may include links to or integrations with third-party websites, products, or services. We are not 
              responsible for their content, practices, or availability. Your interactions with third parties are at your own 
              risk, and we disclaim all liability.
            </p>
          </section>

          <section>
            <h2>11. Termination</h2>
            <p>
              We may terminate or suspend your access to the Services immediately, without notice or liability, for any reason, 
              including breach of these Terms. Upon termination:
            </p>
            <ul>
              <li>Your license to use the Services ends.</li>
              <li>We may delete your account and data (subject to legal requirements).</li>
              <li>Provisions that survive termination (e.g., IP, disclaimers, liability) remain in effect.</li>
            </ul>
            <p>
              You may terminate by ceasing use and closing your account.
            </p>
          </section>

          <section>
            <h2>12. Governing Law and Dispute Resolution</h2>
            <p>
              These Terms are governed by the laws of the State of Wyoming, USA, without regard to conflict of law principles. 
              Any disputes arising from these Terms or the Services shall be resolved exclusively in the state or federal courts 
              located in Sheridan County, Wyoming. You waive any objections to venue or jurisdiction.
            </p>
            <p>
              For EU users or under applicable laws, mandatory consumer protections may apply. We encourage informal resolution 
              first—contact us per Section 14.
            </p>
          </section>

          <section>
            <h2>13. Changes to Terms</h2>
            <p>
              We may update these Terms at any time. We will notify you of material changes by posting the updated Terms here, 
              updating the "Last Updated" date, and emailing registered users where feasible. Your continued use after changes 
              constitutes acceptance. If you disagree, stop using the Services.
            </p>
          </section>

          <section>
            <h2>14. Contact Information</h2>
            <p>
              For questions, complaints, or notices (including DMCA takedowns), contact us at:
            </p>
            <p>
              <strong>Lilley Tech Syndicate LLC</strong><br />
              30 N Gould St Ste N<br />
              Sheridan, WY 82801 USA<br />
              Phone: (307) 204-5225<br />
              Email: legal@lilleytechsyndicate.com (for legal matters) or karl.lilley@gmail.com
            </p>
          </section>

          <section>
            <h2>15. Miscellaneous</h2>
            <ul>
              <li><strong>Severability:</strong> If any provision is invalid, the remainder remains enforceable.</li>
              <li><strong>Waiver:</strong> No waiver of any term is effective unless in writing.</li>
              <li><strong>Assignment:</strong> We may assign these Terms; you may not without our consent.</li>
              <li><strong>Entire Agreement:</strong> These Terms, plus any referenced policies, constitute the full agreement.</li>
              <li><strong>Force Majeure:</strong> We are not liable for delays due to events beyond our control (e.g., natural disasters).</li>
            </ul>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TermsOfService;
